import { render, staticRenderFns } from "./BpSteps.vue?vue&type=template&id=2c2f6f47&scoped=true&"
import script from "./BpSteps.vue?vue&type=script&lang=js&"
export * from "./BpSteps.vue?vue&type=script&lang=js&"
import style0 from "./BpSteps.vue?vue&type=style&index=0&id=2c2f6f47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f6f47",
  null
  
)

export default component.exports